import { render, staticRenderFns } from "./Icms.vue?vue&type=template&id=72995a2c"
import script from "./Icms.vue?vue&type=script&lang=js"
export * from "./Icms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports